export default __webpack_public_path__ + "static/media/right_smile_hero.7759d61c.png";